'use client';

import { useSelector } from '@xstate/store/react';
import { useTranslations } from 'next-intl';

import { FeatureProductInfoMain } from '@/fo/feature/product/info/main';
import {
  storeProductVariant,
  selectModalState
} from '@/fo/store/product-variant';
import { UiKitDrawerBase } from '@/fo/ui/kit/drawer/base';

import { styles } from './FeatureProductModalConfig.styles';

export interface FeatureProductModalConfigProps {
  isAuthorized: boolean;
}

export function FeatureProductModalConfig({
  isAuthorized
}: FeatureProductModalConfigProps) {
  const slots = styles();
  const t = useTranslations();

  const modalState = useSelector(storeProductVariant, selectModalState);
  const { isOpen, product } = modalState;

  return (
    <UiKitDrawerBase
      title={t('product.configurable.selectVolume')}
      open={isOpen}
      direction="right"
      onOpenChange={(open) => {
        if (!open) {
          storeProductVariant.send({ type: 'closeModal' });
        }
      }}
    >
      <div className={slots.title()}>
        {t('product.configurable.selectVolume')}
      </div>

      {product && (
        <FeatureProductInfoMain
          selectedProduct={product}
          baseProduct={product}
          isAuthorized={isAuthorized}
          type="catalog"
          listName="preview"
          maxStockQuantity={product.stockQuantity ?? 0}
        />
      )}
    </UiKitDrawerBase>
  );
}
